import React from "react";
import { Col, Row, Tooltip } from "antd";
import ItemStatus from "./ItemStatus";
import moment from "moment";
import statusDosBeneficios from "./statusDosBeneficios";

const BeneficioStatus = ({ item, index }) => {
  const informacoesDoTooltip = (item) => {
    return statusDosBeneficios[item.status]?.tooltip ? (
      <div className="box-tootip-message">
        <p>{item.status}</p>
        <p>
          Data fim da vigência:{" "}
          {item?.dataFinalVigencia
            ? moment(item?.dataFinalVigencia, "YYYY/MM/DD").format("DD/MM/YYYY")
            : ""}
        </p>
      </div>
    ) : (
      ""
    );
  };

  return (
    <Row style={{ padding: "0.5em" }}>
      <Col
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 6 }}
        xl={{ span: 6 }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Tooltip placement="right" title={informacoesDoTooltip(item)}>
          <ItemStatus status={item.status} style={{ width: "100%", }} />
        </Tooltip>
      </Col>
      <Col span={18}>
        <div className="beneficio-titulo">{item.aposentadoria}</div>
        {item.instituidor ? (
          <>
            <div className="beneficio-subTitulo">
              INSTITUIDOR: {item.instituidor}
            </div>
            {item.status !== "ATIVO" && (
                <>
                  <div>
                    MOTIVO FIM : {item.motivoFimBeneficio}
                  </div>

                  <div>
                    DATA FIM :{" "}
                    {item?.dataFinalVigencia
                      ? moment(item.dataFinalVigencia, "YYYY-MM-DD").format("DD/MM/YYYY")
                      : ""}
                  </div>
                </>
              )}
          </>
        ) : (
          <>
          <div className="beneficio-subTitulo">{item.instituicao}</div>
           {item.status !== "ATIVO" && (
                <>
                  <div>
                    MOTIVO FIM : {item.motivoFimBeneficio}
                  </div>

                  <div>
                    DATA FIM :{" "}
                    {item?.dataFinalVigencia
                      ? moment(item.dataFinalVigencia, "YYYY-MM-DD").format("DD/MM/YYYY")
                      : ""}
                  </div>
                </>
              )}
          </>
          
        )}
      </Col>
    </Row>
  );
};

export default BeneficioStatus;
